var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalley(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "268.5 205.5 1500 350",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Walley") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m692.013 266.7v142.8l-144.9-72.3c-6.2-3.1-13.8-3.1-20 0l-144.9 72.3v-142.8h-46.7-67c-.5 0-.7.7-.3 1l67.3 39.3v142.6c0 13.5 16.7 22 30.1 15.3l171.5-85.6 171.5 85.6c13.4 6.7 30.1-1.8 30.1-15.3v-182.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1033.21 367.9v99.2h-48.597v-24.5c-37.7 17.5-79 30.1-126.3 30.1-58.9 0-91.6-20.2-91.6-65.5 0-51.2 54.9-67.8 116.4-67.8 35.7 0 70.8 6 101.5 14.5-1.3-42.7-52.9-48.3-82-48.3-28.4 0-61.5 3.3-105.5 16.9l-14.2-36.7c40.7-11.9 80-19.2 126-19.2 81.9.1 123.597 25.6 124.297 101.3zm-48.597 41.6v-19.5c-26.8-7.3-58.2-13.6-97.2-13.6-42.7 0-68.8 8.3-68.8 29.4 0 22.8 20.8 27.4 54.9 27.4 30 .1 78.3-12.1 111.1-23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1062.71 205h48.2v262.2h-48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1142.11 205h48.2v262.2h-48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1430.91 400.8h50.5c-11.8 44.9-56.4 71.5-128.2 71.5-80.6 0-136.4-33.1-136.4-102.6s58-102.6 133.4-102.6c76.4 0 134.1 29.2 134.1 113.1h-216.3c4.6 37.4 34.7 52.1 86.2 52.1 46.9 0 67.5-12.8 76.7-31.5zm-160.3-54.7h160.3c-8.5-28.8-36.1-41.3-80.6-41.3-42 0-70.5 12.1-79.7 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1714.31 267.1h54.8l-117.2 213.3c-25.7 47.8-51 75.4-102.8 75.4-25.7 0-46.6-3.4-68.2-7.8v-42.3c25.7 5.8 44.5 7.5 59.3 7.5 29.1 0 44.2-8.5 62.7-43.3l1.4-2.7h-26.7l-109.6-200.1h55.5l95.2 174z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalley);
export default __webpack_public_path__ + "static/media/walley.6f4a98ebcc3a7547acb2dc2261fc9be0.svg";
export { ForwardRef as ReactComponent };